/**
 * AllAll 图片：Flux 系列 + Seedream 4.0，按 modelId 返回对应 buildBody
 */
import { buildBody as buildFluxKontextMax } from './flux-kontext-max'
import { buildBody as buildFluxKontextPro } from './flux-kontext-pro'
import { buildBody as buildFluxPro11Ultra } from './flux-pro-1.1-ultra'
import { buildBody as buildFluxSchnell } from './flux-schnell'
import { buildBody as buildSeedream40 } from './seedream-4-0'

var BUILDERS = {
  'flux-kontext-max': buildFluxKontextMax,
  'flux-kontext-pro': buildFluxKontextPro,
  'flux-pro-1.1-ultra': buildFluxPro11Ultra,
  'flux-schnell': buildFluxSchnell,
  'seedream-4-0': buildSeedream40,
  'seedream-4': buildSeedream40
}

export function buildBodyForModel(modelId, params) {
  var fn = BUILDERS[modelId]
  if (!fn) return null
  return fn(params)
}
